module.exports = __webpack_public_path__ + "static/img/design-2.db5899c7.png";